import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../shared/services/user-services/user.service';
import { ToastrMsgService } from '../shared/services/shared-services/toastr.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent {
  authForm!: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly toastrMsgService: ToastrMsgService) {}
  initForm() {
    this.authForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }
  ngOnInit() {
    this.initForm();
  }
  forgetPassword() {
    if(this.authForm?.valid) {
    this.userService.forgetPassword(this.authForm?.value).subscribe({
      next: (response) => {
        console.log(response)
        if(response?.success) {
          this.toastrMsgService.success(response?.message);
          this.authForm.reset();
          this.router.navigate(['/']);
        }
      },
      error: (error) => {
        this.toastrMsgService.error(error.error.message);
        console.error('Error  getting state:', error);
      },
      complete: () => {
        console.log('Get request completed');
      },
    });
  } else {
    this.toastrMsgService.warning('Invalid Form');
  }
  }
}
